module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"KeepIt Home","short_name":"KeepIt","start_url":"/","background_color":"#4b7bec","theme_color":"#4b7bec","display":"minimal-ui","icon":"src/images/icon_heart.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
